import styled from 'vue3-styled-components';
import { keyframes } from 'vue3-styled-components'

const fadeIn = keyframes`
 from {
    opacity: 0;
    transform: scale(0.9); /* 중앙에서 축소 */
  }
  to {
    opacity: 1;
    transform: scale(1); /* 정상 크기로 확대 */
  }
`;

export const ModalOverlayDiv = styled.div` 
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
`;

export const ModalDivArea = styled.div`
    background: white;
    border-radius: 8px;
    padding: 1em;
    position: relative;
    width: 95%;
    max-width: 95%;
    animation: ${fadeIn} 0.3s ease-out;
  `;

export const ModalCloseBtn = styled.button`
    position: absolute;
    top: -15px;
    right: -10px;
    background: #333;
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 1.5em;
    z-index: 100;
  `;

export const ModalScrollArea = styled.div`
    height: 100%;
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    
    /* 웹킷 기반 브라우저 스크롤바 스타일링 */
    &::-webkit-scrollbar {
      width: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f5f9;
      border-radius: 10px;
      margin: 4px 0;
    }
    
    &::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #cbd5e1, #94a3b8);
      border-radius: 10px;
      border: 2px solid #f1f5f9;
      transition: all 0.2s ease;
      
      &:hover {
        background: linear-gradient(135deg, #94a3b8, #64748b);
        transform: scale(1.05);
      }
      
      &:active {
        background: linear-gradient(135deg, #64748b, #475569);
      }
    }
    
    &::-webkit-scrollbar-corner {
      background: #f1f5f9;
    }
    
    /* Firefox 스크롤바 스타일링 */
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 #f1f5f9;
    
    /* 스크롤바가 보이지 않을 때도 공간 확보 */
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
    
    /* 스크롤바 버튼 숨기기 (선택사항) */
    &::-webkit-scrollbar-button {
      display: none;
    }
  `;
